export default class RootWrappers {
    provides() {
        return {
            withWrappers: () => require('./wrapper').default,
        };
    }
}
